import React, { useState, createContext } from 'react'

// A DEFAULT, not bare `createContext()`. Consumers destructure this
// (`const { setSearchShown } = useContext(ModalContext)`), so outside a provider the read was
// `undefined` and the destructure threw — taking down the whole page rather than degrading. That
// is what `/product/:id` hit the moment it started rendering <Search>. Outside a provider there
// is no search chrome to toggle, so a no-op is the honest behaviour. Fixing it here covers every
// consumer (Search, ListingSearch, RCListingsPage) and any future one, instead of a `?? {}` guard
// repeated at each call site.
export const ModalContext = createContext({
    searchShown: false,
    setSearchShown: () => {},
})

const ModalContextProvider = (props) => {
    const [ searchShown, setShown ] = useState(false)

    const [ context, setContext ] = useState({
        searchShown,
        setSearchShown: (shown) => {
            context.searchShown = shown
            setShown(shown)
            setContext({...context})
        }
    })

    return (
        <ModalContext.Provider value={context}>
            {props.children}
        </ModalContext.Provider>
    )
}

export default ModalContextProvider